import { CaseDocumentEnum } from '@supoui/shared/model/case-document';
import { Injectable } from '@angular/core';
import { Adapter } from '@supoui/shared/interfaces/adapter';

export class CaseDocumentTag {
  name: CaseDocumentEnum;
  public constructor(init?: Partial<CaseDocumentTag>) {
    Object.assign(this, init);
  }
}

@Injectable({
  providedIn: 'root'
})
export class CaseDocumentTagAdapter implements Adapter<CaseDocumentTag> {
  adapt(item: any): CaseDocumentTag {
    return new CaseDocumentTag({
      name: item.name
    });
  }
}
